import {useSceneExtensionsContext} from 'sceneExtensions/contexts';
import type {FieldExtensionEnum} from '../types';

/**
 * Use this for more robust check for current extension, as
 * unsubscribeRef.current may get out of sync
 */
export const useIsCurrentExtension = (
  extensionType: FieldExtensionEnum,
  fieldId?: string,
): boolean => {
  const extensionsContext = useSceneExtensionsContext();
  return (
    extensionsContext.currentExtension?.type === extensionType &&
    (!fieldId ||
      extensionsContext.currentExtension?.fieldContext?.sourceField?.fieldId ===
        fieldId)
  );
};
